<template>
	<personal-layout cur-menu="collectlist">
		<div class="collect-list-container">
			<div class="top-action" v-show="goodsList.length != 0 || loading">
				<div class="action-left">
					<span class="action-title">我的收藏</span>
					<span class="action-count" v-if="isBatchMode && selectedCount > 0">已选{{ selectedCount }}件</span>
				</div>
				<div class="action-right">
					<el-button v-if="isBatchMode" class="cancel-btn" @click="exitBatchMode">返回</el-button>
					<el-button class="batch-btn" :class="{ 'batch-btn-active': isBatchMode }" @click="toggleBatchMode">
						{{ isBatchMode ? "取消收藏" : "批量管理" }}
					</el-button>
				</div>
			</div>

			<div class="collect-list-wrap" v-loading="loading" element-loading-text="加载中">
				<div class="empty-cart-wrap flex-col flex-center" v-if="!loading && goodsList.length == 0">
					<img class="empty-cart-img" src="../../assets/images/empty-cart.png" />
					<div class="empty-cart-tips">您的收藏是空的，快去选购商品吧</div>
					<el-button class="empty-cart-btn" type="danger" @click="goShopping">前往商城</el-button>
				</div>

				<div v-else class="goods-list flex-row">
					<div
						class="goods-item flex-col"
						v-for="(item, index) in goodsList"
						:key="index"
						:class="{ 'is-selected': item.checked }"
						@click="toGoodsDetail(item)"
					>
						<div class="goods-img-wrap">
							<div v-if="isBatchMode" class="checkbox-wrap" @click.stop>
								<div class="checkbox" :class="{ checked: item.checked }" @click="toggleCheck(item)">
									<i v-if="item.checked" class="el-icon-check"></i>
								</div>
							</div>
							<img class="goods-img" :src="$utils.set400Img(item.coverPic)" @error="$utils.set400Img('')" />
						</div>
						<div class="goods-name text-ellipsis" :title="item.goodsName">
							{{ item.goodsName }}
						</div>
						<div class="goods-price">
							<span class="price-symbol">{{ $currency.symbol }}</span>
							<span class="price-value">{{ $utils.filterTrailingZeros(item.priceMember) }}</span>
							<span v-if="item.score > 0" class="price-score">+{{ item.score }}积分</span>
						</div>
					</div>
				</div>
			</div>

			<div class="pagination-wrap" v-show="goodsList.length != 0">
				<el-pagination
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:current-page.sync="pageIndex"
					:page-size="pageSize"
					:page-sizes="[10,20, 50,100]"
					layout="total, sizes, prev, pager, next, jumper"
					:total="totalCount"
				>
				</el-pagination>
			</div>
		</div>
	</personal-layout>
</template>

<script>
	import personalLayout from "../../components/mine/PersonalLayout.vue";
	import goodsUtils from "../../utils/api-utils/api-goods.js";
	import { getParam } from "../../utils/api-utils/api-params.js";

	export default {
		name: "collect-list",
		components: {
			personalLayout,
		},
		data() {
			return {
				goodsList: [],
				pageIndex: 1,
				pageSize: 20,
				totalCount: 0,
				loading: false,
				isBatchMode: false,
				showGoodsName: true,
				isShowPrice: false,
			};
		},
		created() {
			this.initData();
		},
		activated() {
			this.initData();
		},
		methods: {
			async initData() {
				this.showGoodsName = !["795330"].includes(localStorage.getItem("JackyunUserName"));
				this.isShowPrice = this.$utils.getIsShowPrice();
				this.getCollectionGoodsList();
			},
			async getCollectionGoodsList() {
				this.loading = true;
				let obj = {
					customerId: localStorage.getItem("pc_customerId") || 0,
					channelId: "0",
					requestSource: "1",
					memberGrade: localStorage.getItem("pc_defaultMemberGradeId"),
					pageIndex: this.pageIndex - 1,
					pageSize: this.pageSize,
				};

				// 先获取收藏总数
				this.getCollectionCount();

				this.$request.jackyunPost(
					{
						method: "jmall.goods.getcollectiongoodslist",
						jsonStr: JSON.stringify(obj),
						
					},
					async (res) => {
						if (res.code == 200) {
							let result = res.result.data || [];
							this.goodsList = await goodsUtils.completeFullGoodsInfoForList(result, "goodsList");
							this.goodsList = this.goodsList.map((item) => ({
								...item,
								checked: false,
							}));
						} else {
							this.$message.error(res.msg || "获取收藏商品列表失败");
						}
						this.loading = false;
					}
				);
			},
			getCollectionCount() {
                let obj = {
					customerId: localStorage.getItem("pc_customerId") || 0,
					channelId: "0",
					requestSource: "1",
					memberGrade: localStorage.getItem("pc_defaultMemberGradeId"),
				};
				this.$request.jackyunPost(
					{
						method: "jmall.goods.countcollectiongoodslist",
                        jsonStr: JSON.stringify(obj),
					},
					(res) => {
						if (res.code == 200) {
							this.totalCount = res.result.data || 0;
						}
					}
				);
			},
			handleSizeChange(val) {
				this.pageSize = val;
				this.getCollectionGoodsList();
			},
			handleCurrentChange(val) {
				this.pageIndex = val;
				this.getCollectionGoodsList();
			},
			toGoodsDetail(item) {
				if (this.isBatchMode) {
					this.toggleCheck(item);
					return;
				}
				let encode = window.btoa(window.encodeURIComponent(item.goodsId));
				this.$router.push({
					name: "goodsdetail",
					query: {
						id: encode,
					},
				});
			},
			toggleCheck(item) {
				item.checked = !item.checked;
			},
			toggleBatchMode() {
				if (this.isBatchMode) {
					this.batchCancelCollect();
				} else {
					this.isBatchMode = true;
				}
			},
			exitBatchMode() {
				this.isBatchMode = false;
				this.goodsList.forEach((item) => {
					item.checked = false;
				});
			},
			batchCancelCollect() {
				let selectedGoods = this.goodsList.filter((item) => item.checked);
				if (selectedGoods.length === 0) {
					this.$message.warning("请先选择要取消收藏的商品");
					return;
				}

				this.$confirm("确定取消收藏所选的" + selectedGoods.length + "件商品？", "提示", {
					confirmButtonText: "确定",
					cancelButtonText: "取消",
					type: "warning",
				}).then(() => {
					let goodsIds = selectedGoods.map((item) => item.goodsId)
                    let obj = {
                        customerId: localStorage.getItem("pc_customerId") || 0,
						channelId: "0",
						goodsIdList: goodsIds,
						upperId: "0",
                    };
					this.$request.jackyunPost(
						{
							method: "jmall.goods.deletecollectionList",
							jsonStr: JSON.stringify(obj)
						},
						(res) => {
							if (res.code == 200) {
								this.$message.success("批量取消收藏成功");
								this.exitBatchMode();
								this.getCollectionGoodsList();
							} else {
								this.$message.error(res.msg || "批量取消收藏失败");
							}
						}
					);
				});
			},
			goShopping() {
				this.$router.push({
					name: "goodslist",
					params: {},
				});
			},
		},
		computed: {
			selectedCount() {
				return this.goodsList.filter((item) => item.checked).length;
			},
		},
	};
</script>

<style scoped="scoped">
	.collect-list-container {
		display: flex;
		flex-direction: column;
		height: calc(100vh - 110px);
	}

	.top-action {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 15px 20px;
		background-color: #fff;
		/* border-bottom: 1px solid #eee; */
		flex-shrink: 0;
	}

	.collect-list-wrap {
		padding: 0 20px 0 46px;
		overflow-y: auto;
		flex: 1;
	}

	.collect-list-wrap::-webkit-scrollbar {
		width: 6px;
	}

	.collect-list-wrap::-webkit-scrollbar-thumb {
		background-color: #ddd;
		border-radius: 3px;
	}

	.empty-cart-wrap {
		margin: 20px auto;
		max-width: calc(100vw - 60px);
		background-color: #fff;
		position: relative;
		height: calc(100vh - 200px);
	}

	.empty-cart-img {
		width: 151px;
		height: 128px;
	}

	.empty-cart-tips {
		color: #ccc;
		font-size: 18px;
		line-height: 120px;
	}

	.empty-cart-btn {
		width: 200px;
		height: 70px;
		font-size: 20px;
	}

	.goods-list {
		padding: 0;
		flex-wrap: wrap;
	}

	.goods-item {
		width: calc(20% - 20px);
		padding-bottom: 18px;
		margin: 0 5px 10px;
		position: relative;
		background-color: #fff;
		text-align: center;
		align-items: center;
		cursor: pointer;
		transition: all 0.3s;
		border:2px solid #eeeeee;
	}

	.goods-item.is-selected {
		background-color: #fff5f5;
		border:2px solid #fff5f5;
	}

	.goods-img {
		max-width: 100%;
		max-height: 100%;
		margin: 0 auto;
	}

	.goods-img-wrap {
		max-width: 170px;
		height: 170px !important;
		
		padding:10px 14px 0;
		margin: 0;
	}

	.goods-name {
		width: 90%;
		margin: 10px auto 5px;
		text-align: left;
		font-size: 14px;
		line-height: 20px;
		height: 20px;
	}

	.goods-price {
		color: #ff2b2a;
		font-size: 18px;
		width: 90%;
		margin: 0 auto;
		text-align: left;
	}

	.price-symbol {
		font-size: 14px;
	}

	.price-value {
		font-size: 18px;
	}

	.price-score {
		font-size: 12px;
		color: #ff5757;
		margin-left: 5px;
	}

	.checkbox-wrap {
		position: absolute;
		top: 0px;
		left: 0px;
		z-index: 10;
		margin: 8px;
	}

	.checkbox {
		width: 20px;
		height: 20px;
		border-radius: 50%;
		border: 2px solid #ccc;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
		transition: all 0.3s;
		background-color: #fff;
	}

	.checkbox.checked {
		background-color: #f56c6c;
		border-color: #f56c6c;
	}

	.checkbox .el-icon-check {
		color: #fff;
		font-size: 12px;
		font-weight: bold;
	}

	.action-left {
		display: flex;
		align-items: center;
	}

	.action-title {
		font-size: 18px;
		/* font-weight: bold; */
		letter-spacing: 2px;
	}

	.action-count {
		font-size: 14px;
		color: #ff5757;
		margin-left: 5px;
	}

	.action-right {
		display: flex;
		align-items: center;
	}

	.batch-btn {
		background-color: #f56c6c !important;
		color: #fff !important;
		border: none;
		padding: 10px 20px;
		border-radius: 4px;
		font-size: 14px;
	}

	.batch-btn:hover {
		background-color: #f56c6c !important;
		color: #fff !important;
	}

	.batch-btn.batch-btn-active {
		background-color: #f56c6c !important;
	}

	.batch-btn.batch-btn-active:hover {
		background-color: #f56c6c !important;
		color: #fff !important;
	}

	.cancel-btn {
		color: #666;
		border: 1px solid #ddd;
		padding: 10px 20px;
		border-radius: 4px;
		font-size: 14px;
		margin-right: 10px;
	}

	.cancel-btn:hover {
		color: #333;
		border-color: #ccc;
	}

	.pagination-wrap {
		padding: 15px 20px;
		background-color: #fff;
		/* border-top: 1px solid #eee; */
		text-align: center;
		flex-shrink: 0;
	}
</style>

<style>
	.el-message-box__status {
		display: none !important;
	}
</style>
